forms-orders-checking-orders-csv
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }"  enctype="multipart/form-data")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-file(tag-scope="{ this.tagScope }.inputs.file")
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.orders.checking_orders_csv')
